// extracted by mini-css-extract-plugin
module.exports = {"molecule__tab-car-carousel-container":"styles_molecule__tab-car-carousel-container__Jyj_K","slide-container":"styles_slide-container__X0BGf","back-line":"styles_back-line__PWOue"};